import React, {useState} from 'react';
import {Button, Col, Flex} from "antd";
import {StyledApproveButton, StyledRejectButton} from "./ActionButtons.styled";
import {ActionButtonsProps} from "../../models";
import {connect} from "react-redux";
import {getAdminPanelProduct, productApprove, productReject} from "../../actions/AdminPanel.action";
import {withRouter} from "../../../../utils/services/with-router";

const ActionButtons = ({id,productApprove,productReject,onSubmitBtnClick} : ActionButtonsProps) => {
    const [loading, setLoading] = useState<boolean>(false);

    const _productApprove = () => {
        setLoading(true);
        let model = {
            productId:id,
            statusId:1
        }
        productApprove(model)
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {
                    onSubmitBtnClick()

                }
            })
            .catch((e: any) => {
            });
    };
    const _productReject = (statusId:number) => {
        setLoading(true);
        let model = {
            productId:id,
            statusId:statusId
        }
        productReject(model)
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {
                    onSubmitBtnClick()

                }
            })
            .catch((e: any) => {
            });
    };
    return (
        <Flex gap={"middle"} wrap={"wrap"}>
            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledApproveButton loading={loading} onClick={_productApprove}>
                    تایید
                </StyledApproveButton>
            </Col>
            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledRejectButton loading={loading} onClick={() => _productReject(2)}>
                    عکس نامناسب
                </StyledRejectButton>
            </Col><Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledRejectButton loading={loading} onClick={() => _productReject(3)}>
                    اطلاعات ناقص
                </StyledRejectButton>
            </Col><Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledRejectButton loading={loading} onClick={() => _productReject(4)}>
                    عدم رعایت قوانین
                </StyledRejectButton>
            </Col><Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledRejectButton loading={loading} onClick={() => _productReject(5)}>
                    قیمت‌ غیرواقعی
                </StyledRejectButton>
            </Col><Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledRejectButton loading={loading} onClick={() => _productReject(6)}>
                    کلمات یا عبارات نامناسب
                </StyledRejectButton>
            </Col>
            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledRejectButton loading={loading} onClick={() => _productReject(7)}>
                    آگهی تکراری یا مشابه
                </StyledRejectButton>
            </Col>
            <Col xs={11} sm={11} md={11} lg={11} xl={11}>
                <StyledRejectButton loading={loading} onClick={() => _productReject(8)}>
                    دسته بندی غلط
                </StyledRejectButton>
            </Col>
        </Flex>
    );
};

export default connect(null, {productApprove,productReject})(withRouter(ActionButtons));
